import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: 'Modern Office Complex',
      category: 'commercial',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800',
      description: '50,000 sq ft commercial space'
    },
    {
      id: 2,
      title: 'Luxury Residential Villa',
      category: 'residential',
      image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800',
      description: 'Custom 6-bedroom luxury home'
    },
    {
      id: 3,
      title: 'Industrial Warehouse',
      category: 'industrial',
      image: 'https://images.stockcake.com/public/3/e/2/3e2f926e-9268-47a6-9b44-68857a210807_large/industrial-warehouse-interior-stockcake.jpg',
      description: '100,000 sq ft storage facility'
    },
    {
      id: 4,
      title: 'Retail Shopping Center',
      category: 'commercial',
      image: 'https://images.unsplash.com/photo-1555636222-cae831e670b3?w=800',
      description: 'Multi-tenant retail complex'
    },
    {
      id: 5,
      title: 'Contemporary Home',
      category: 'residential',
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
      description: 'Modern architectural design'
    },
    {
      id: 6,
      title: 'Hotel Renovation',
      category: 'renovation',
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
      description: 'Complete interior transformation'
    }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section id="projects" className="projects">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title">Our Projects</h2>
          <p className="section-subtitle">
            Showcasing excellence in construction and design
          </p>
        </div>

        <div className="project-filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All Projects
          </button>
          <button 
            className={`filter-btn ${filter === 'commercial' ? 'active' : ''}`}
            onClick={() => setFilter('commercial')}
          >
            Commercial
          </button>
          <button 
            className={`filter-btn ${filter === 'residential' ? 'active' : ''}`}
            onClick={() => setFilter('residential')}
          >
            Residential
          </button>
          <button 
            className={`filter-btn ${filter === 'industrial' ? 'active' : ''}`}
            onClick={() => setFilter('industrial')}
          >
            Industrial
          </button>
          <button 
            className={`filter-btn ${filter === 'renovation' ? 'active' : ''}`}
            onClick={() => setFilter('renovation')}
          >
            Renovation
          </button>
        </div>

        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
